function Article({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28 28"
      fill="currentColor"
      className={className}
    >
      <path
        d="M8.45801 19.5413H16.0413V17.7913H8.45801V19.5413ZM8.45801 14.8746H19.5413V13.1247H8.45801V14.8746ZM8.45801 10.208H19.5413V8.45801H8.45801V10.208ZM6.19199 23.9163C5.60267 23.9163 5.10384 23.7121 4.69551 23.3038C4.28717 22.8955 4.08301 22.3966 4.08301 21.8073V6.19199C4.08301 5.60267 4.28717 5.10384 4.69551 4.69551C5.10384 4.28717 5.60267 4.08301 6.19199 4.08301H21.8073C22.3966 4.08301 22.8955 4.28717 23.3038 4.69551C23.7121 5.10384 23.9163 5.60267 23.9163 6.19199V21.8073C23.9163 22.3966 23.7121 22.8955 23.3038 23.3038C22.8955 23.7121 22.3966 23.9163 21.8073 23.9163H6.19199ZM6.19199 22.1663H21.8073C21.8971 22.1663 21.9793 22.1289 22.0541 22.0541C22.1289 21.9793 22.1663 21.8971 22.1663 21.8073V6.19199C22.1663 6.10224 22.1289 6.01996 22.0541 5.94515C21.9793 5.87037 21.8971 5.83298 21.8073 5.83298H6.19199C6.10224 5.83298 6.01996 5.87037 5.94515 5.94515C5.87037 6.01996 5.83298 6.10224 5.83298 6.19199V21.8073C5.83298 21.8971 5.87037 21.9793 5.94515 22.0541C6.01996 22.1289 6.10224 22.1663 6.19199 22.1663Z"
        fill="#757575"
      />
    </svg>
  );
}

export default Article;
